import React, { lazy } from 'react';
import { Outlet } from 'react-router';

const DeferredCompFundingReport = lazy(
  () => import('../ebisprint/reports/MJC/DeferredCompFundingReport')
);

const PrintAddendumC = lazy(() => import('../ebisprint/addc/PrintAddendumC'));
const PrintMjc = lazy(() => import('../ebisprint/mjc/PrintMjc'));
const PrintMjcViaScreenshot = lazy(() =>
  import('../ebisprint/mjc/PrintMjc').then((module) => ({
    default: module.PrintMjcViaScreenshot,
  }))
);
const PrintPlayerAddendumF = lazy(
  () => import('../ebisprint/playerletters/PrintPlayerAddendumF')
);
const CBTAssessmentReport = lazy(
  () => import('../ebisprint/reports/MJC/payroll/CBTAssessmentReport')
);
const CapitalizedPaymentReport = lazy(
  () => import('../ebisprint/reports/MJC/CapitalizedPaymentsReport')
);
const PrintPlayerAddendumG = lazy(
  () => import('../ebisprint/playerletters/PrintPlayerAddendumG')
);
const PrintPlayerLetterMaster = lazy(
  () => import('../ebisprint/playerletters/printPlayerLetterMaster')
);
const PrintPlayerProfile = lazy(
  () => import('../ebisprint/playerprofile/PrintPlayerProfile')
);
const WidgetPdf = lazy(() => import('../ebisprint/widget/WidgetPdf'));
const GenericPdf = lazy(() => import('../ebisprint/reports/GenericPdf'));

const RecertificationMaintenanceReport = lazy(
  () => import('../ebisprint/reports/tx/RecertificationMaintenanceReport')
);

const SelectablePlayerPdf = lazy(
  () => import('../ebisprint/reports/R5/SelectablePlayerPdf')
);

const DraftByRoundPdf = lazy(
  () => import('../ebisprint/reports/R4/DraftByRoundPdf')
);

const MnRosterReport = lazy(
  () => import('../ebisprint/reports/rosters/MnRosterReport')
);

const WelcomeKit = lazy(() => import('../ebisprint/cep/WelcomeKit'));
const PendingWelcomeKits = lazy(
  () => import('../ebisprint/cep/PendingWelcomeKits')
);
const MajorLeagueFreeAgentsPdf = lazy(
  () =>
    import('../ebisprint/reports/elected-free-agency/MajorLeagueFreeAgentsPdf')
);

const EbisPrintFrame = lazy(() => import('../frames/EbisPrintFrame'));
const DailyTxBulletinPrint = lazy(
  () => import('../ebisprint/reports/tx/DailyTxBulletinPrint')
);
const WaiverBulletinPrint = lazy(
  () =>
    import('../ebisprint/reports/wv/waiver-bulletin-print/WaiverBulletinPrint')
);
const AssignmentAgreement = lazy(
  () =>
    import('../ebisprint/reports/tx/assignmentAgreement/AssignmentAgreement')
);
const AssignmentAgreementPtbnl = lazy(
  () => import('../ebisprint/reports/tx/AssignmentAgreementPtbnl')
);
const NoTradeWaiver = lazy(
  () => import('../ebisprint/reports/tx/NoTradeWaiver')
);
const TenFiveWaiver = lazy(
  () => import('../ebisprint/reports/tx/TenFiveWaiver')
);

const PostSeasonRosterArranged = lazy(
  () => import('../ebisprint/reports/rosters/PostSeasonRosterArranged')
);
const PrintContractLanguagePreview = lazy(
  () => import('../ebisprint/contract-language/PrintContractLanguagePreview')
);

export default [
  {
    path: 'ebisprint',
    element: (
      <EbisPrintFrame>
        <Outlet />
      </EbisPrintFrame>
    ),
    children: [
      {
        path: '/ebisprint/addc/:mncCId',
        element: <PrintAddendumC />,
      },
      {
        path: '/ebisprint/mjc-print/:mjcId',
        element: <PrintMjc />,
      },
      {
        path: '/ebisprint/mjc-print-screenshot',
        element: <PrintMjcViaScreenshot />,
      },
      {
        path: '/ebisprint/player-letter-print',
        element: <PrintPlayerLetterMaster />,
      },
      {
        path: '/ebisprint/addf',
        element: <PrintPlayerAddendumF />,
      },
      {
        path: '/ebisprint/addg',
        element: <PrintPlayerAddendumG />,
      },
      {
        path: '/ebisprint/cbt-assessment-report',
        element: <CBTAssessmentReport />,
      },
      {
        path: '/ebisprint/capitalized-payments-report',
        element: <CapitalizedPaymentReport />,
      },
      {
        path: '/ebisprint/player-profile/:playerId',
        element: <PrintPlayerProfile />,
      },
      {
        path: '/ebisprint/recert-maintenance-report',
        element: <RecertificationMaintenanceReport />,
      },
      {
        path: '/ebisprint/widget-pdf',
        element: <WidgetPdf />,
      },
      {
        path: '/ebisprint/generic-pdf',
        element: <GenericPdf />,
      },
      {
        path: '/ebisprint/r5-selectables',
        element: <SelectablePlayerPdf />,
      },
      {
        path: '/ebisprint/r4-draft-by-round-export',
        element: <DraftByRoundPdf />,
      },
      {
        path: '/ebisprint/mn-roster-report',
        element: <MnRosterReport />,
      },
      {
        path: '/ebisprint/deferred-comp-funding',
        element: <DeferredCompFundingReport />,
      },
      {
        path: '/ebisprint/welcome-kit',
        element: <WelcomeKit />,
      },
      {
        path: '/ebisprint/pending-welcome-kits',
        element: <PendingWelcomeKits />,
      },
      {
        path: '/ebisprint/major-league-free-agents',
        element: <MajorLeagueFreeAgentsPdf />,
      },
      {
        path: '/ebisprint/tx-bulletin-print',
        element: <DailyTxBulletinPrint />,
      },
      {
        path: '/ebisprint/waiver-bulletin-print',
        element: <WaiverBulletinPrint />,
      },
      {
        path: '/ebisprint/assignment-agreement',
        element: <AssignmentAgreement />,
      },
      {
        path: '/ebisprint/assignment-agreement-ptbnl',
        element: <AssignmentAgreementPtbnl />,
      },
      {
        path: '/ebisprint/no-trade-waiver',
        element: <NoTradeWaiver />,
      },
      {
        path: '/ebisprint/ten-five-waiver',
        element: <TenFiveWaiver />,
      },
      {
        path: '/ebisprint/post-season-roster',
        element: <PostSeasonRosterArranged />,
      },
      {
        path: '/ebisprint/contract-language-preview',
        element: <PrintContractLanguagePreview />,
      },
    ],
  },
];
